module.exports = __webpack_public_path__ + "media/images/pc/specials/common/plan_house-400aedd6434060bf9b554223ac096e3d.jpg";